// package: user_service
// file: user_service.proto

var user_service_pb = require("./user_service_pb");
var grpc = require("@improbable-eng/grpc-web").grpc;

var UserService = (function () {
  function UserService() {}
  UserService.serviceName = "user_service.UserService";
  return UserService;
}());

UserService.GetUserByEmail = {
  methodName: "GetUserByEmail",
  service: UserService,
  requestStream: false,
  responseStream: false,
  requestType: user_service_pb.GetUserRequest,
  responseType: user_service_pb.UserResponse
};

UserService.ListUsersByPhoneNumber = {
  methodName: "ListUsersByPhoneNumber",
  service: UserService,
  requestStream: false,
  responseStream: false,
  requestType: user_service_pb.GetUserRequest,
  responseType: user_service_pb.UserResponseList
};

UserService.GetMe = {
  methodName: "GetMe",
  service: UserService,
  requestStream: false,
  responseStream: false,
  requestType: user_service_pb.GetMeRequest,
  responseType: user_service_pb.UserResponse
};

UserService.UpdateMe = {
  methodName: "UpdateMe",
  service: UserService,
  requestStream: false,
  responseStream: false,
  requestType: user_service_pb.UserRequest,
  responseType: user_service_pb.UserResponse
};

UserService.UpdateEmail = {
  methodName: "UpdateEmail",
  service: UserService,
  requestStream: false,
  responseStream: false,
  requestType: user_service_pb.UpdateEmailRequest,
  responseType: user_service_pb.UserResponse
};

UserService.GetLineUser = {
  methodName: "GetLineUser",
  service: UserService,
  requestStream: false,
  responseStream: false,
  requestType: user_service_pb.GetLineUserRequest,
  responseType: user_service_pb.LineUserResponse
};

UserService.GetLineUserByUserID = {
  methodName: "GetLineUserByUserID",
  service: UserService,
  requestStream: false,
  responseStream: false,
  requestType: user_service_pb.GetLineUserByUserIDRequest,
  responseType: user_service_pb.LineUserResponse
};

UserService.GetCoupon = {
  methodName: "GetCoupon",
  service: UserService,
  requestStream: false,
  responseStream: false,
  requestType: user_service_pb.GetCouponRequest,
  responseType: user_service_pb.CouponResponse
};

UserService.ListCoupons = {
  methodName: "ListCoupons",
  service: UserService,
  requestStream: false,
  responseStream: false,
  requestType: user_service_pb.ListCouponsRequest,
  responseType: user_service_pb.CouponResponseList
};

UserService.ListUsersCoupons = {
  methodName: "ListUsersCoupons",
  service: UserService,
  requestStream: false,
  responseStream: false,
  requestType: user_service_pb.ListUsersCouponsRequest,
  responseType: user_service_pb.ListUsersCouponsResponse
};

UserService.AttachCouponToUser = {
  methodName: "AttachCouponToUser",
  service: UserService,
  requestStream: false,
  responseStream: false,
  requestType: user_service_pb.AttachCouponToUserRequest,
  responseType: user_service_pb.ListUsersCouponsResponse
};

UserService.UseCoupon = {
  methodName: "UseCoupon",
  service: UserService,
  requestStream: false,
  responseStream: false,
  requestType: user_service_pb.UseCouponRequest,
  responseType: user_service_pb.ListUsersCouponsResponse
};

UserService.GetAuthenticatorIdentity = {
  methodName: "GetAuthenticatorIdentity",
  service: UserService,
  requestStream: false,
  responseStream: false,
  requestType: user_service_pb.GetAuthenticatorIdentityRequest,
  responseType: user_service_pb.AuthenticatorIdentity
};

UserService.SetAuthenticatorIdentity = {
  methodName: "SetAuthenticatorIdentity",
  service: UserService,
  requestStream: false,
  responseStream: false,
  requestType: user_service_pb.AuthenticatorIdentity,
  responseType: user_service_pb.AuthenticatorIdentity
};

UserService.Sign = {
  methodName: "Sign",
  service: UserService,
  requestStream: false,
  responseStream: false,
  requestType: user_service_pb.SignRequest,
  responseType: user_service_pb.SignResponse
};

UserService.SendResetPasswordMail = {
  methodName: "SendResetPasswordMail",
  service: UserService,
  requestStream: false,
  responseStream: false,
  requestType: user_service_pb.ResetPasswordRequest,
  responseType: user_service_pb.ResetPasswordResponse
};

UserService.Verify = {
  methodName: "Verify",
  service: UserService,
  requestStream: false,
  responseStream: false,
  requestType: user_service_pb.VerifyRequest,
  responseType: user_service_pb.VerifyResponse
};

exports.UserService = UserService;

function UserServiceClient(serviceHost, options) {
  this.serviceHost = serviceHost;
  this.options = options || {};
}

UserServiceClient.prototype.getUserByEmail = function getUserByEmail(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(UserService.GetUserByEmail, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

UserServiceClient.prototype.listUsersByPhoneNumber = function listUsersByPhoneNumber(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(UserService.ListUsersByPhoneNumber, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

UserServiceClient.prototype.getMe = function getMe(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(UserService.GetMe, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

UserServiceClient.prototype.updateMe = function updateMe(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(UserService.UpdateMe, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

UserServiceClient.prototype.updateEmail = function updateEmail(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(UserService.UpdateEmail, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

UserServiceClient.prototype.getLineUser = function getLineUser(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(UserService.GetLineUser, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

UserServiceClient.prototype.getLineUserByUserID = function getLineUserByUserID(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(UserService.GetLineUserByUserID, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

UserServiceClient.prototype.getCoupon = function getCoupon(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(UserService.GetCoupon, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

UserServiceClient.prototype.listCoupons = function listCoupons(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(UserService.ListCoupons, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

UserServiceClient.prototype.listUsersCoupons = function listUsersCoupons(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(UserService.ListUsersCoupons, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

UserServiceClient.prototype.attachCouponToUser = function attachCouponToUser(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(UserService.AttachCouponToUser, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

UserServiceClient.prototype.useCoupon = function useCoupon(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(UserService.UseCoupon, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

UserServiceClient.prototype.getAuthenticatorIdentity = function getAuthenticatorIdentity(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(UserService.GetAuthenticatorIdentity, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

UserServiceClient.prototype.setAuthenticatorIdentity = function setAuthenticatorIdentity(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(UserService.SetAuthenticatorIdentity, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

UserServiceClient.prototype.sign = function sign(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(UserService.Sign, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

UserServiceClient.prototype.sendResetPasswordMail = function sendResetPasswordMail(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(UserService.SendResetPasswordMail, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

UserServiceClient.prototype.verify = function verify(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(UserService.Verify, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

exports.UserServiceClient = UserServiceClient;

var AdminUserService = (function () {
  function AdminUserService() {}
  AdminUserService.serviceName = "user_service.AdminUserService";
  return AdminUserService;
}());

AdminUserService.GetUser = {
  methodName: "GetUser",
  service: AdminUserService,
  requestStream: false,
  responseStream: false,
  requestType: user_service_pb.GetUserRequest,
  responseType: user_service_pb.UserResponse
};

AdminUserService.GetUserEmailHistory = {
  methodName: "GetUserEmailHistory",
  service: AdminUserService,
  requestStream: false,
  responseStream: false,
  requestType: user_service_pb.GetUserRequest,
  responseType: user_service_pb.EmailHistory
};

AdminUserService.UpdateUser = {
  methodName: "UpdateUser",
  service: AdminUserService,
  requestStream: false,
  responseStream: false,
  requestType: user_service_pb.UserRequest,
  responseType: user_service_pb.UserResponse
};

AdminUserService.CreateUser = {
  methodName: "CreateUser",
  service: AdminUserService,
  requestStream: false,
  responseStream: false,
  requestType: user_service_pb.UserRequest,
  responseType: user_service_pb.UserResponse
};

AdminUserService.DeleteUser = {
  methodName: "DeleteUser",
  service: AdminUserService,
  requestStream: false,
  responseStream: false,
  requestType: user_service_pb.DeleteUserRequest,
  responseType: user_service_pb.DeleteUserResponse
};

AdminUserService.GetUserByEmail = {
  methodName: "GetUserByEmail",
  service: AdminUserService,
  requestStream: false,
  responseStream: false,
  requestType: user_service_pb.GetUserRequest,
  responseType: user_service_pb.UserResponse
};

AdminUserService.ListUsersByPhoneNumber = {
  methodName: "ListUsersByPhoneNumber",
  service: AdminUserService,
  requestStream: false,
  responseStream: false,
  requestType: user_service_pb.GetUserRequest,
  responseType: user_service_pb.UserResponseList
};

AdminUserService.ListUser = {
  methodName: "ListUser",
  service: AdminUserService,
  requestStream: false,
  responseStream: false,
  requestType: user_service_pb.ListUserRequest,
  responseType: user_service_pb.UserResponseList
};

AdminUserService.GetLineUser = {
  methodName: "GetLineUser",
  service: AdminUserService,
  requestStream: false,
  responseStream: false,
  requestType: user_service_pb.GetLineUserRequest,
  responseType: user_service_pb.LineUserResponse
};

AdminUserService.GetLineUserByUserID = {
  methodName: "GetLineUserByUserID",
  service: AdminUserService,
  requestStream: false,
  responseStream: false,
  requestType: user_service_pb.GetLineUserByUserIDRequest,
  responseType: user_service_pb.LineUserResponse
};

AdminUserService.GetLineUserByExternalID = {
  methodName: "GetLineUserByExternalID",
  service: AdminUserService,
  requestStream: false,
  responseStream: false,
  requestType: user_service_pb.GetLineUserByExternalIDRequest,
  responseType: user_service_pb.LineUserResponse
};

AdminUserService.CreateLineUser = {
  methodName: "CreateLineUser",
  service: AdminUserService,
  requestStream: false,
  responseStream: false,
  requestType: user_service_pb.LineUserRequest,
  responseType: user_service_pb.LineUserResponse
};

AdminUserService.UpdateLineUser = {
  methodName: "UpdateLineUser",
  service: AdminUserService,
  requestStream: false,
  responseStream: false,
  requestType: user_service_pb.LineUserRequest,
  responseType: user_service_pb.LineUserResponse
};

AdminUserService.GetCoupon = {
  methodName: "GetCoupon",
  service: AdminUserService,
  requestStream: false,
  responseStream: false,
  requestType: user_service_pb.GetCouponRequest,
  responseType: user_service_pb.CouponResponse
};

AdminUserService.ListCoupons = {
  methodName: "ListCoupons",
  service: AdminUserService,
  requestStream: false,
  responseStream: false,
  requestType: user_service_pb.ListCouponsRequest,
  responseType: user_service_pb.CouponResponseList
};

AdminUserService.CreateCoupon = {
  methodName: "CreateCoupon",
  service: AdminUserService,
  requestStream: false,
  responseStream: false,
  requestType: user_service_pb.CreateCouponRequest,
  responseType: user_service_pb.CouponResponse
};

AdminUserService.UpdateCoupon = {
  methodName: "UpdateCoupon",
  service: AdminUserService,
  requestStream: false,
  responseStream: false,
  requestType: user_service_pb.CreateCouponRequest,
  responseType: user_service_pb.CouponResponse
};

AdminUserService.ListUsersCoupons = {
  methodName: "ListUsersCoupons",
  service: AdminUserService,
  requestStream: false,
  responseStream: false,
  requestType: user_service_pb.ListUsersCouponsRequest,
  responseType: user_service_pb.ListUsersCouponsResponse
};

AdminUserService.AttachCouponToUser = {
  methodName: "AttachCouponToUser",
  service: AdminUserService,
  requestStream: false,
  responseStream: false,
  requestType: user_service_pb.AttachCouponToUserRequest,
  responseType: user_service_pb.ListUsersCouponsResponse
};

AdminUserService.DetachCouponFromUser = {
  methodName: "DetachCouponFromUser",
  service: AdminUserService,
  requestStream: false,
  responseStream: false,
  requestType: user_service_pb.DetachCouponFromUserRequest,
  responseType: user_service_pb.ListUsersCouponsResponse
};

AdminUserService.UseCoupon = {
  methodName: "UseCoupon",
  service: AdminUserService,
  requestStream: false,
  responseStream: false,
  requestType: user_service_pb.UseCouponRequest,
  responseType: user_service_pb.ListUsersCouponsResponse
};

AdminUserService.ListUsersByIDs = {
  methodName: "ListUsersByIDs",
  service: AdminUserService,
  requestStream: false,
  responseStream: false,
  requestType: user_service_pb.ListUsersByIDsRequest,
  responseType: user_service_pb.UserResponseList
};

exports.AdminUserService = AdminUserService;

function AdminUserServiceClient(serviceHost, options) {
  this.serviceHost = serviceHost;
  this.options = options || {};
}

AdminUserServiceClient.prototype.getUser = function getUser(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AdminUserService.GetUser, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AdminUserServiceClient.prototype.getUserEmailHistory = function getUserEmailHistory(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AdminUserService.GetUserEmailHistory, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AdminUserServiceClient.prototype.updateUser = function updateUser(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AdminUserService.UpdateUser, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AdminUserServiceClient.prototype.createUser = function createUser(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AdminUserService.CreateUser, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AdminUserServiceClient.prototype.deleteUser = function deleteUser(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AdminUserService.DeleteUser, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AdminUserServiceClient.prototype.getUserByEmail = function getUserByEmail(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AdminUserService.GetUserByEmail, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AdminUserServiceClient.prototype.listUsersByPhoneNumber = function listUsersByPhoneNumber(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AdminUserService.ListUsersByPhoneNumber, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AdminUserServiceClient.prototype.listUser = function listUser(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AdminUserService.ListUser, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AdminUserServiceClient.prototype.getLineUser = function getLineUser(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AdminUserService.GetLineUser, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AdminUserServiceClient.prototype.getLineUserByUserID = function getLineUserByUserID(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AdminUserService.GetLineUserByUserID, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AdminUserServiceClient.prototype.getLineUserByExternalID = function getLineUserByExternalID(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AdminUserService.GetLineUserByExternalID, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AdminUserServiceClient.prototype.createLineUser = function createLineUser(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AdminUserService.CreateLineUser, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AdminUserServiceClient.prototype.updateLineUser = function updateLineUser(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AdminUserService.UpdateLineUser, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AdminUserServiceClient.prototype.getCoupon = function getCoupon(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AdminUserService.GetCoupon, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AdminUserServiceClient.prototype.listCoupons = function listCoupons(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AdminUserService.ListCoupons, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AdminUserServiceClient.prototype.createCoupon = function createCoupon(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AdminUserService.CreateCoupon, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AdminUserServiceClient.prototype.updateCoupon = function updateCoupon(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AdminUserService.UpdateCoupon, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AdminUserServiceClient.prototype.listUsersCoupons = function listUsersCoupons(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AdminUserService.ListUsersCoupons, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AdminUserServiceClient.prototype.attachCouponToUser = function attachCouponToUser(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AdminUserService.AttachCouponToUser, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AdminUserServiceClient.prototype.detachCouponFromUser = function detachCouponFromUser(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AdminUserService.DetachCouponFromUser, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AdminUserServiceClient.prototype.useCoupon = function useCoupon(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AdminUserService.UseCoupon, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AdminUserServiceClient.prototype.listUsersByIDs = function listUsersByIDs(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AdminUserService.ListUsersByIDs, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

exports.AdminUserServiceClient = AdminUserServiceClient;

